/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Regular expressions to validate phone number.
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export abstract class PhoneRegex {
    public static readonly defaultRegex = '^$|^[- +()]*[0-9][- +()0-9]*$';
}
